<template>
    <AppPage title="Pedidos" subtitle="Gerenciar os Pedidos">

        <b-button slot="actions" type="is-primary" rounded :outlined="showAllProducts" @click="showProductsToggle">
            {{ showAllProducts ? "Ocultar produtos" : "Mostrar produtos" }}
        </b-button>
        
        <div class="list-orders">
            <order-list-item 
                v-for="order in orders" 
                :key="order.id" 
                :order="order" 
                :set-show-products="showAllProducts" 
            />
        </div>
    </AppPage>
</template>

<script>

import AppPage from "@/components/AppPage";
import database from "@/services/database";
import OrderListItem from "@/modules/orders/components/OrderListItem";

import {remove} from "../orders.actions";

const actions = {remove};

export default {
    name: "listOrders",

    components: {
        AppPage, 
        OrderListItem
    },

    data() {
        return {
            showAllProducts: true,
            orders: []
        }
    },

    methods: {
        executeAction(action, parameter) {
            const actionExecute = actions[action];
            if (actionExecute) {
                actionExecute(parameter);
            }
        },

        showProductsToggle(){
            this.showAllProducts = !this.showAllProducts;
        }
    },

    created() {

        let loading = this.$buefy.loading.open();

        this._unsubscriveOrdersSnapshots = database.collection('orders')
            .orderBy('createdAt', 'desc')
            .limit(200)
            .onSnapshot((spapshot) => {
                const orders = []
                spapshot.forEach(document => {
                    orders.push({
                        id: document.id,
                        data: document.data()
                    });
                });

                this.orders = orders;

                if (loading) {
                    loading.close();
                }
            })
    },

    beforeDestroy() {
        if (this._unsubscriveOrdersSnapshots) {
            this._unsubscriveOrdersSnapshots();
        }
    }
}
</script>

